import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { pricePointParser } from 'parser/pricePointParser';
import { getPricePointChartData } from 'gqlQueries/pricePoint';
const errorMessage: string = 'Something went wrong!';

function useFetchPricePointGraph() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);

    const [fetchPricePoint, { data: pricePointData, loading: pricePointDataLoading, error: pricePointDataError }] =
        useLazyQuery(getPricePointChartData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            if (error) return;
            const { getPricePointGraphData } = payload;
            if (getPricePointGraphData && 'data' in getPricePointGraphData) {
                const parsedChartData = pricePointParser(getPricePointGraphData, pricePointConfig);
                const legends = getPricePointGraphData?.legendsLst || [];
                setData({ chartData: parsedChartData, min: 0, max: 100, legends: legends || [] });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        throwError: (error: any) => {
            onFetchError(error);
        },
        clearGraphData: () => {
            setData(null);
            setError(null);
        },
        fetchPricePointGraph: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setLoading(true);
            setError(null);
            fetchPricePoint(variables);
            //onFetchComplete(variables);
        },
    };
}

export { useFetchPricePointGraph };
